import React, {useEffect, useRef, useState} from 'react';

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

ChartJS.defaults.font.size = 16;
ChartJS.defaults.font.family = "'Graphik', sans-serif";
ChartJS.defaults.color = '#007681';
ChartJS.defaults.borderColor = '#007681';

function getChartData() {
  return {
    labels:
      window.NBIjs.indexOverTime.labels,
    datasets:
      window.NBIjs.indexOverTime.datasets
  };
}

function ChartFilter(props) {
  return (
    <div className={((props.className)?props.className:'')}>
      <div className="intro" dangerouslySetInnerHTML={{__html:props.introContent}} />
      <div className={'chart-filter'}>
        <select value={props.filterState.value} onChange={(event) => {
          props.onFilterChange(event.target.value)
        }}>
          <option value="all">All</option>
          {props.chartData.datasets.map((dataset, index) => {
            return <option key={index} value={index}>{dataset.setName}</option>
          })}
        </select>
      </div>
    </div>
  )
}

function NBIIndexOverTime(props) {

  const [introContent, setIntroContent ] = useState(jQuery('#' + props.args.id + ' .intro.hidden').html());
  const [filterState, setFilter ] = useState({value:'all'});
  const [chartData, setChartData] = useState(getChartData());
  const [chartOptions, setChartOptions] = useState(
    {
      aspectRatio: 1.13407,
      onResize:onChartResize,
      responsive: true,
      plugins: {
        legend: {
          display: false,
        }
      },
      scales: {
        x: {
          grid: {
            color:'#007681',
            drawTicks: true,
            tickLength: 8,
            borderDash:[8,541],
            borderDashOffset: 8,
            tickColor:'#007681',
            borderColor:'#007681',
          },

          ticks: {
            // color:'#007681',
            padding:15,
          },
          offset:true,
        },

        y: {
          min:window.NBIjs.indexOverTime.min,
          max:window.NBIjs.indexOverTime.max,
          grid: {
            color:'#007681',
            drawTicks: true,
            tickLength: 8,
            borderDash:[8,1200],
            borderDashOffset: 0,
            tickColor:'#007681',
            borderColor:'#007681',
          },
          ticks: {
            // color:'#007681',
            padding:32,
          },
          offset: true,
        }
      }
    }
  );

  function getIntroContent(id) {
    return jQuery(id).html();
  }

  function onChartResize(chart, size) {
      if (!chartRef.current || !chartRef.current.chartArea) {
        return;
      }
      setTimeout(function () {
        setChartOptions({...chartOptions,
          redrawNow:size,
          // onResize:onChartResize,
          scales:{
            ...chartOptions.scales,
            x:{
              ...chartOptions.scales.x,
              grid: {
                ...chartOptions.scales.x.grid,
                borderDash:[8,chartRef.current.chartArea.height-8],
              }
            },
          }
        });
      })

  }

  function onFilterChange(value) {
    setFilter({value: value})
  }

  function filterPlots() {
    //set filtered out plots into transparent
    setChartData({
      ...chartData,
      datasets: ([...chartData.datasets].map((dataset, index) => {
        const newColor = (filterState.value === 'all' || index === parseInt(filterState.value)) ?  dataset.colorCache : 'rgba(0,0,0,0)';
        return {
          ...dataset,
          backgroundColor:newColor,
          borderColor:newColor,
        }
      }))
    })
  }
  const chartRef = useRef();


  useEffect(() => {
    if (chartRef.current) {
      onChartResize(chartRef.current, false); //sending false won't trigger redraw
    }
  }, []);

  useEffect(() => {
    if (chartOptions.redrawNow) {
      chartRef.current.update();
    }
    // else {
    //   onChartResize(chartRef.current, false); //sending false won't trigger redraw
    // }
  }, [chartOptions.redrawNow]);

  useEffect(() => {
    filterPlots();
  }, [filterState]);

  useEffect(() => {
    chartRef.current.update();
  }, [chartData]);

    return (
        <>
            <div className={'left'}>
              <ChartFilter chartData={chartData} filterState={filterState} onFilterChange={onFilterChange} className={'for-wp-mobile'} introContent={introContent} />
              <Line options={chartOptions} data={chartData} ref={chartRef} />
            </div>
            <div className={'right'}>
              <ChartFilter chartData={chartData} filterState={filterState} onFilterChange={onFilterChange} className={'for-wp-desktop'} introContent={introContent} />

              <div className={'chart-legend'}>
                {chartData.datasets.map((dataset, index) => {
                  return <div className={'item'} key={index} onClick={()=>{onFilterChange(index)}}><span className={'dot'} style={{backgroundColor:dataset.backgroundColor}}></span> {dataset.setName}</div>
                })}
              </div>
            </div>
        </>
    );
}

export { NBIIndexOverTime }
